import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild, Input, ChangeDetectorRef } from '@angular/core';
import { Building, Company, User, UserType } from 'toolbandi-ui-lib';
import { Search, CrudService, MessageService, SortDirection, SharedDataService } from 'elbuild-ui-lib-core';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { forkJoin, Observable, Subscription, combineLatest } from 'rxjs';
import { BuildingEditComponent } from '../building-edit/building-edit.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DialogService, ListFiltersComponent } from 'elbuild-ui-componentslib';

@Component({
	selector: 'app-building-list',
	templateUrl: './building-list.component.html',
	styleUrls: ['./building-list.component.scss']
})
export class BuildingListComponent implements OnInit, AfterViewInit, OnDestroy {

	loading: boolean = false;
	rows: Building[];

	advancedSearch: Search = new Search('building', 'name', 'building');

	@ViewChild('listfilters', {}) listfilters: ListFiltersComponent;
	showAdvancedSearch: boolean = true;

	@Input()
	companyid: number;
	loggedUser: User;
	subcription: Subscription;

	constructor(
		private buildingService: CrudService<Building>,
		private messageService: MessageService,
		private translateService: TranslateService,
		private dialogService: DialogService,
		private router: Router,
		private cdr: ChangeDetectorRef,
		private modalService: NgbModal,
		private sharedDataService: SharedDataService) {

		this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		this.advancedSearch.setSortField('id');
	}

	ngAfterViewInit() {
		const urlparamsreq = this.listfilters.readParams();

		const requests: Observable<any>[] = [urlparamsreq];

		if (!this.loggedUser) {
			const userrequest = this.sharedDataService.currentLoggedUser;
			requests.push(userrequest);
		}

		this.subcription = combineLatest(requests).subscribe(data => {

			if (data[1]) {
				this.loggedUser = data[1];
			}
			if (this.loggedUser.utype === UserType.company) {
				this.companyid = this.loggedUser.companyid;
			}
			this.search(data[0]);

		});
	}

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.subcription) {
			this.subcription.unsubscribe();
		}
	}


	load() {
		this.loading = true;
		this.rows = [];
		this.cdr.detectChanges();

		if (this.companyid) {
			this.advancedSearch.addSimpleFilter('companyid', this.companyid);
		}

		const datarequest = this.buildingService.searchEntities(Building, 'building', this.advancedSearch, this.advancedSearch.page);
		const countrequest = this.buildingService.countEntities(Building, 'building', this.advancedSearch);

		forkJoin([datarequest, countrequest]).subscribe(results => {
			this.advancedSearch.page.setTotal(results[1].ct);
			this.rows = results[0];
			this.loading = false;
		}, ({ error }) => {
			this.messageService.sendError(error, this.translateService.instant('labels.error-occurred'));
			this.loading = false;
		});
	}


	onPageChange(pageInfo: any) {
		this.advancedSearch.page.setPageNumber(pageInfo.offset);
		this.listfilters.addQueryParams();
		this.load();
	}

	onSortChange(sortInfo: any) {
		const sort = sortInfo.sorts[0];
		this.advancedSearch.setSortField(sort.prop);
		this.advancedSearch.setSortDirection(sort.dir);
		this.listfilters.addQueryParams();
		this.load();
	}

	onActivate(event: any) {
		if (true /*this.aclService.hasPermission('centri.detail')*/) {
			if (event.type === 'dblclick') {
				this.router.navigate([`/company/building/view/${event.row.id}`], { queryParamsHandling: 'merge' });
			}
		}
	}


	search(searchParams?: any) {
		if (searchParams) {
			this.advancedSearch = searchParams;
		}
		this.load();
	}

	rowClass = (row: any) => {
		return '';
	}

	get page() {
		if (this.advancedSearch) {
			return this.advancedSearch.page;
		} else {
			return undefined;
		}
	}

	delete(row: Building, event: any) {
		this.dialogService.openConfirmModal({
			message: this.translateService.instant('labels.warning-building-delete'),
			hasIcon: true,
			type: 'warning'
		}).then(result => {
			if (result) {
				this.buildingService.deleteEntity(Building, 'building', row).subscribe(() => {
					this.translateService.get(['labels.building-deleted', 'labels.buildings']).subscribe(messages => {
						this.messageService.sendSuccess(messages['labels.building-deleted'], messages['labels.buildings']);
						this.load();
					});
				});
			}
		});
	}


	edit(buildingid?: number) {
		const modal = this.modalService.open(BuildingEditComponent, {
			centered: true,
			size: 'lg',
			backdrop: 'static',
			keyboard: false
		});
		modal.componentInstance.companyid = this.companyid;
		if (buildingid) {
			modal.componentInstance.load(buildingid);
		}
		modal.result.then((newItem: Building) => {
			this.load();
		}).catch(() => { });
	}

}
